// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./InsuredKyc.fulfillment";
import DefaultFields from "../../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../../Cob.helpers";
import OptionsList from "../../../../components/OptionsList/OptionsList";
import EditableField from "../../../../components/EditableField/EditableField";
import NumberField from "../../../../components/NumberField/NumberField";
import TextView from "../../../../../../components/TextView/TextView";

export default class InsuredKyc extends React.PureComponent {
	static companyExclusive = false;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

    if (prevProps.draftData !== props.draftData) {
      if (props.draftData) {
        // get the draftData props specific to this section only
        const draftDataProps = getPropertiesByPrefix(props.draftData, ['futur_insured_kyc_', 'checkbox_', 'advice_' , 'customer_']);
        // parse the draftData props into state.fields
        const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);        
        this.setState(
          {
            fields: {...newFieldsState}
          },
          async () => {          
              await delay(200);
              onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
          }
        );
      }
		}
	}

	render() {
		const {props, state} = this;
		const {title, session} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<OptionsList
						type="radio"
						orientation="vertical"
						name="futur_insured_kyc_meeting_form"
						options={state.fields.futur_insured_kyc_meeting_form.options}
						onChange={this._onOptionsListChange}
					/>

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Syftet med försäkringen"}
						name="futur_insured_kyc_purpose"
						options={state.fields.futur_insured_kyc_purpose.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_insured_kyc_purpose.options[3].checked && (
						<EditableField
							name="futur_insured_kyc_purpose_other"
							label="Ange"
							value={state.fields.futur_insured_kyc_purpose_other}
							valid={state.validFields.futur_insured_kyc_purpose_other}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							style={{marginTop: "10px", maxWidth: "300px"}}
						/>
					)}

					{session.isCompany && (
						<OptionsList
							type="radio"
							orientation="horizontal"
							description={"Gäller placeringsförslaget en tjänstepension?"}
							name="checkbox_accounttype"
							options={state.fields.checkbox_accounttype.options}
							onChange={this._onOptionsListChange}
							style={{marginTop: "40px"}}
						/>
					)}

					{!session.isCompany && (
						<input type={"hidden"} name={"checkbox_accounttype"} value={"nej"}/>
					)}

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Hur stor del av den totala förmögenheten avser du att placera vid detta tillfälle?"}
						name="checkbox_advice_invpercentage"
						options={state.fields.checkbox_advice_invpercentage.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Vilken är den planerade insättningen i samband med tecknandet av försäkringen?"}
						name="futur_insured_kyc_initial_premium"
						options={state.fields.futur_insured_kyc_initial_premium.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_insured_kyc_initial_premium.options[4].checked && (
						<div style={{display: "block", width: "150px", marginTop: "10px"}}>
							<EditableField
								Component={NumberField}
								name="futur_insured_kyc_initial_premium_other"
								label="Ange estimat"
								value={state.fields.futur_insured_kyc_initial_premium_other}
								valid={state.validFields.futur_insured_kyc_initial_premium_other}
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}
								unit={"kr"}
								style={{maxWidth: "150px"}}
							/>
						</div>
					)}

					<OptionsList
						type="radio"
						orientation="vertical"
						description={"Vilken är den planerade insättningen per år?"}
						name="futur_insured_kyc_yearly_premium"
						options={state.fields.futur_insured_kyc_yearly_premium.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.futur_insured_kyc_yearly_premium.options[5].checked && (
						<div style={{display: "block", width: "150px", marginTop: "10px"}}>
							<EditableField
								Component={NumberField}
								name="futur_insured_kyc_yearly_premium_other"
								label="Ange"
								value={state.fields.futur_insured_kyc_yearly_premium_other}
								valid={state.validFields.futur_insured_kyc_yearly_premium_other}
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}
								unit={"kr"}
								style={{maxWidth: "150px"}}
							/>
						</div>
					)}

					<h4 style={{margin: "40px 0 0 0"}}>Kundens syfte och mål med placeringen</h4>
					<p style={{margin: "10px 0"}}>
						Beskrivning av kundens syfte och mål med placeringen, inklusive risktolerans.
					</p>

					<EditableField
						name="advice_allocation_motivation_risc"
						Component={TextView}
						label={`${1000 - state.fields.advice_allocation_motivation_risc.length} tecken kvar`}
						value={state.fields.advice_allocation_motivation_risc}
						maxLength={1000}
						disableEnterKey={true}
						valid={
							state.fields.advice_allocation_motivation_risc.length > 0 &&
							state.fields.advice_allocation_motivation_risc.length <= 1000 ? true : null
						}
						resize="vertical"
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>

					<h4 style={{margin: "40px 0 0 0"}}>Kundens ekonomiska förhållanden</h4>
					<p style={{margin: "10px 0"}}>
						Beskrivning av kundens ekonomiska situation, inklusive förmåga att bära förlust.
					</p>
					<EditableField
						name="advice_customer_financial_suitability"
						Component={TextView}
						maxLength={570}
						disableEnterKey={true}
						label={`${570 - state.fields.advice_customer_financial_suitability.length} tecken kvar`}
						value={state.fields.advice_customer_financial_suitability}
						valid={
							state.fields.advice_customer_financial_suitability.length > 0 &&
							state.fields.advice_customer_financial_suitability.length <= 570 ? true : null
						}
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>

					<p style={{margin: "20px 0 10px 0"}}>
						Var kommer betalningsmedlen ifrån (ex. aktier, fonder, kontanter)?
					</p>
					<EditableField
						name="customer_aml_origin"
						Component={TextView}
						maxLength={570}
						disableEnterKey={true}
						label={`${570 - state.fields.customer_aml_origin.length} tecken kvar`}
						value={state.fields.customer_aml_origin}
						valid={
							state.fields.customer_aml_origin.length > 0 &&
							state.fields.customer_aml_origin.length <= 570 ? true : null
						}
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>

					<h4 style={{margin: "40px 0 0 0"}}>Kundens kunskap och erfarenhet</h4>
					<p style={{margin: "10px 0"}}>
						Beskrivning av kundens kunskaper om och erfarenheter av den specifika typen av produkt/tjänst.
					</p>
					<EditableField
						name="advice_customer_suitability_knowledge"
						Component={TextView}
						maxLength={570}
						disableEnterKey={true}
						label={`${570 - state.fields.advice_customer_suitability_knowledge.length} tecken kvar`}
						value={state.fields.advice_customer_suitability_knowledge}
						valid={
							state.fields.advice_customer_suitability_knowledge.length > 0 &&
							state.fields.advice_customer_suitability_knowledge.length <= 570 ? true : null
						}
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>

					<h4 style={{margin: "40px 0 0 0"}}>Mötesnoteringar</h4>
					<p style={{margin: "10px 0"}}>
						Övergripande information om vad som har diskuterats med kunden, samt vilka produkter/tjänster
						som det har redogjorts för.
					</p>

					<EditableField
						name="advice_notes"
						Component={TextView}
						label={`${840 - state.fields.advice_notes.length} tecken kvar`}
						value={state.fields.advice_notes}
						maxLength={840}
						disableEnterKey={true}
						valid={
							state.fields.advice_notes.length > 0 &&
							state.fields.advice_notes.length <= 840 ? true : null
						}
						resize="vertical"
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>
				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

function _getFields() {
	return [
		"futur_insured_kyc_meeting_form",

		"futur_insured_kyc_purpose",
		"futur_insured_kyc_purpose_other",

		"futur_insured_kyc_initial_premium",
		"futur_insured_kyc_initial_premium_other",

		"futur_insured_kyc_yearly_premium",
		"futur_insured_kyc_yearly_premium_other",
		"advice_allocation_motivation_risc",
	];
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	let initialState = {
		validFields: {},
		fields: {
			futur_insured_kyc_meeting_form: {
				options: [
					{
						label: "Försäkring tecknad vid fysiskt möte med förmedlare/rådgivare",
						value: "PhysicalMeeting",
						checked: false
					},
					{label: "Försäkring tecknad på distans", value: "Distance", checked: false}
				]
			},

			futur_insured_kyc_purpose: {
				options: [
					{label: "Pensionssparande", value: "Pension", checked: false},
					{label: "Målsparande", value: "Objective", checked: false},
					{label: "Placering", value: "Investments", checked: false},
					{label: "Annat", value: "Other", checked: false},
				]
			},
			futur_insured_kyc_purpose_other: "",

			checkbox_accounttype: {
				options: [
					{label: "Nej", value: "nej", checked: false},
					{label: "Ja", value: "tinsurance", checked: false}
				]
			},

			checkbox_advice_invpercentage: {
				options: [
					{label: "1-25%", value: "1-25", checked: false},
					{label: "26-50%", value: "26-50", checked: false},
					{label: "51-75%", value: "51-75", checked: false},
					{label: "76-100%", value: "76-100", checked: false}
				]
			},

			futur_insured_kyc_initial_premium: {
				options: [
					{label: "0 - 100 000 kr", value: "Amount0To100K", checked: false},
					{label: "100 001 - 500 000 kr", value: "Amount100KTo500K", checked: false},
					{label: "500 001 - 1 000 000 kr", value: "Amount500KTo1M", checked: false},
					{label: "1 000 001 - 5 000 000 kr", value: "Amount1MTo5M", checked: false},
					{label: "över 5 000 000 kr", value: "AmountAbove5M", checked: false}
				]
			},
			futur_insured_kyc_initial_premium_other: "",

			futur_insured_kyc_yearly_premium: {
				options: [
					{
						label: "Endast engångsinsättning i samband med tecknandet av försäkringen",
						value: "NoYearlyPremium",
						checked: false
					},
					{label: "0 - 100 000 kr", value: "Amount0To100K", checked: false},
					{label: "100 001 - 500 000 kr", value: "Amount100KTo500K", checked: false},
					{label: "500 001 - 1 000 000 kr", value: "Amount500KTo1M", checked: false},
					{label: "1 000 001 - 5 000 000 kr", value: "Amount1MTo5M", checked: false},
					{label: "över 5 000 000 kr", value: "AmountAbove5M", checked: false}
				]
			},
			futur_insured_kyc_yearly_premium_other: "",

			advice_allocation_motivation_risc: "",
			advice_customer_financial_suitability: "",
			customer_aml_origin: "",
			advice_customer_suitability_knowledge: "",
			advice_notes: "",
		}
	};

	// Private individuals - tjänstepension not applicable
	if (!this.props.session.isCompany) {
		initialState.fields.checkbox_accounttype.options[0].checked = true;
	}

	return initialState;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/InsuredKyc/Fair/InsuredKyc.js